import { render, staticRenderFns } from "./RelatedCard.vue?vue&type=template&id=778ee194&scoped=true&"
import script from "./RelatedCard.vue?vue&type=script&lang=js&"
export * from "./RelatedCard.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCard.vue?vue&type=style&index=0&id=778ee194&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778ee194",
  null
  
)

export default component.exports